import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    assesmentOpinion:[]
}

export const fetchassesmentOpinion = createAsyncThunk('assesmentOpinion/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/assestmentOpinion`)
    return response.data
  })


let userSlice = createSlice({
  name:'assestmentOpinion',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchassesmentOpinion.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchassesmentOpinion.fulfilled,(state,action)=>{
          state.isLoading = false
          state.assesmentOpinion = action.payload
      })
      .addCase(fetchassesmentOpinion.rejected,(state,payload)=>{
          state.isLoading = false
         // state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;